import React, { FC } from "react";

//first value is the default
export interface IFlexContainerProps {
    direction?: "row" | "column" | "row-reverse" | "column-reverse";
    wrap?: "nowrap" | "wrap" | "wrap-reverse";
    justifyContent?: "flex-start" | "flex-end" | "start" | "end" | "left" | "right" | "center" | "space-between" | "space-around" | "space-evenly";
    alignItems?: "stretch" | "start" | "end" | "center" | "baseline";
    alignContent?: "normal" | "start" | "end" | "center" | "space-between" | "space-around" | "space-evenly" | "stretch";
    gap?: number;
    flex?: boolean; // if this container is also a flex item;
    flexSize?: number; // optional flex size override if flex item (if not provided this will just be 1)
    className?: string;
    ariaLabel?: string;
    style?: React.CSSProperties;
}

export const getFlexStyles = (props: IFlexContainerProps): React.CSSProperties => {
    return {
        display: "flex",
        flexDirection: props.direction ? props.direction : "row",
        flexWrap: props.wrap ? props.wrap : "nowrap",
        justifyContent: props.justifyContent ? props.justifyContent : "flex-start",
        alignItems: props.alignItems ? props.alignItems : "stretch",
        alignContent: props.alignContent ? props.alignContent : "normal",
        ...(props.gap && { gap: props.gap }),
        ...(props.flex && { flex: props.flexSize ? props.flexSize : 1 }),
        ...props.style
    }
}

export const FlexContainer: FC<IFlexContainerProps> = (props) => {
    return (
        <div aria-label={props.ariaLabel} className={`c-flexContainer ${props.className ? props.className : ""}`} style={getFlexStyles(props)}>
            {props.children}
        </div>
    );
}